export default {
    data () {
        return {
            pickerOptions: {},
            pickerModel: []
        };
    },
    created () {
        this.getPickerOptions();
        this.pickerModel = [this.$moment().subtract(6, 'days').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')];
    },
    watch: {
        pickerModel: {
            handler () {
                this.model.fromDate=this.pickerModel[0];
                this.model.untilDate=this.pickerModel[1];
            },
            deep: true
        },
        '$i18n.locale': {
            handler () {
                this.getPickerOptions();
            },
            deep: true
        },
    },
    methods: {
        getPickerOptions () {
            this.pickerOptions = {
                firstDayOfWeek: 1,
                shortcuts: [{
                    text: this.$i18n.t('datepicker_shortcuts.today'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        //start.setTime(start.getTime());
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$i18n.t('datepicker_shortcuts.yesterday'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate()-1);
                        end.setDate(end.getDate()-1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$i18n.t('datepicker_shortcuts.last_week'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$i18n.t('datepicker_shortcuts.last_month'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$i18n.t('datepicker_shortcuts.last_3_months'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            };
        }
    }
}